// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"21c78584","239":"d1e2eca3","732":"2175ea94","977":"9a07272c"}[chunkId] + ".chunk.js";
};